__turbopack_context__.v({
  "bannerGroup": "IaczYq_bannerGroup",
  "buttonsRow": "IaczYq_buttonsRow",
  "card": "IaczYq_card",
  "cardTightSpacing": "IaczYq_cardTightSpacing",
  "condensedTrustSignals": "IaczYq_condensedTrustSignals",
  "desktopAttributes": "IaczYq_desktopAttributes",
  "desktopImages": "IaczYq_desktopImages",
  "desktopImagesVariant": "IaczYq_desktopImagesVariant",
  "desktopLayout": "IaczYq_desktopLayout",
  "desktopProductInfo": "IaczYq_desktopProductInfo",
  "hideCarouselArrows": "IaczYq_hideCarouselArrows",
  "iconButton": "IaczYq_iconButton",
  "imageInfoRow": "IaczYq_imageInfoRow",
  "infoLine": "IaczYq_infoLine",
  "infoLineIcon": "IaczYq_infoLineIcon",
  "infoSections": "IaczYq_infoSections",
  "likeOverlay": "IaczYq_likeOverlay",
  "mainImage": "IaczYq_mainImage",
  "mobileAttributes": "IaczYq_mobileAttributes",
  "productInfo": "IaczYq_productInfo",
  "productInfoPrice": "IaczYq_productInfoPrice",
  "sellerActionButton": "IaczYq_sellerActionButton",
  "sellerActionsDesktop": "IaczYq_sellerActionsDesktop",
  "sellerActionsMobile": "IaczYq_sellerActionsMobile",
  "sellerRow": "IaczYq_sellerRow",
  "tabletImage": "IaczYq_tabletImage",
  "thumbnail": "IaczYq_thumbnail",
  "thumbnailActive": "IaczYq_thumbnailActive",
  "thumbnailImage": "IaczYq_thumbnailImage",
  "thumbnailStrip": "IaczYq_thumbnailStrip",
  "titlePriceGroup": "IaczYq_titlePriceGroup",
  "viewDetailsButton": "IaczYq_viewDetailsButton",
});
